import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

interface PaymentMethodSelectCardProps {
  icon?: ReactNode;
  label: string;
  tariff: string;
}

export const PaymentMethodSelectCard = ({
  icon,
  label,
  tariff,
}: PaymentMethodSelectCardProps) => {
  const [t] = useTranslation("global");

  return (
    <div className="flex flex-row items-center justify-center gap-4 py-1">
      {icon && <div className="flex-shrink-0">{icon}</div>}
      <div className="flex flex-col">
        <p className="text-center font-semibold text-sm leading-tight mt-1">
          {t(`Quoter.PaymentMethodDesktop.${label}`)}
        </p>
        <p className="text-center text-xs text-gray-500 leading-tight">
          {t(`Quoter.PaymentMethodFee`)} {tariff} USD
        </p>
        <p className="w-fit bg-[#3D73F31A] text-primary-600 font-medium rounded-full py-1 px-3 text-xs mt-1">
          {t(`Quoter.Time.${label}`)}
        </p>
      </div>
    </div>
  );
};
